import { SubmissionError } from '#helper/submission-error';
import { FETCH_SHIPMENT_FILES, POST_SHIPMENT_FILES, DELETE_SHIPMENT_FILES } from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { getAuth, getTimeZone, getRequestOptions } from '#helper';

export const fetchShipmentFiles = id => async dispatch =>
  dispatch(fetchAdditions(`shipment/${id}/file`, FETCH_SHIPMENT_FILES));

export const postShipmentFiles = (id, files) => async dispatch => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('file', file.file, `${file.name}.${file.extension}`);
    formData.append('descriptions', file.description ?? '');
  });

  const res = await fetch(webPortalApi.buildApiUrl(`shipment/${id}/file`), {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${getAuth()}`,
      Timezone: getTimeZone()
    }
  });
  const response = await res.json();

  if (!res.ok) {
    dispatch(
      snackBarError({
        message: 'Error in request',
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  dispatch({
    type: POST_SHIPMENT_FILES,
    payload: response
  });

  return { success: true };
};

export const deleteShipmentFiles = (id, files) => async dispatch => {
  const res = await Promise.all(files.map(file => fetch(webPortalApi.buildApiUrl(`shipment/${id}/file/${file.id}`), {
    method: 'DELETE',
    ...getRequestOptions()
  })));
  const response = await Promise.all(res.map(r => r.json()));

  const [deletedIds, notDeletedNames] = files.reduce((a, c, index) => {
    if (response[index].success) {
      a[0].push(c.id);
    } else {
      a[1].push(c.name);
    }

    return a;
  }, [[], []]);

  if (notDeletedNames.length > 0) {
    dispatch({
      type: DELETE_SHIPMENT_FILES,
      payload: deletedIds
    });

    dispatch(
      snackBarError({
        message: `Error in request. Current file${notDeletedNames.length > 1 ? 's' : ''}: ${notDeletedNames.join(', ')} not deleted.`,
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  dispatch({
    type: DELETE_SHIPMENT_FILES,
    payload: deletedIds
  });

  return { success: true };
};
